import { type ChangeEvent } from 'react';
import { Switch as MuiSwitch, FormControlLabel } from '@material-ui/core';

import { type FormInputProps } from './types';
import { useFormInputChange } from './useFormInputChange';

type SwitchProps = FormInputProps<boolean>;

const Switch = (props: SwitchProps) => {
  const { value, label, className, disabled } = props;
  const emit = useFormInputChange(props);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) =>
    emit(event.target.checked);

  const control = (
    <MuiSwitch
      checked={value}
      onChange={handleChange}
      color="primary"
      disabled={disabled}
    />
  );

  if (label === undefined) {
    return control;
  }

  return (
    <FormControlLabel className={className} control={control} label={label} />
  );
};

export default Switch;
